import { useState } from "react";
import { callBackend } from "../components/callBackend";
import { Button, Container } from "react-bootstrap";
import DataTable from "../components/DataTable";
import EventsData from "../data/events.json";
import Loader from "../components/Loader"; // 1. Import the Loader

export default function Winners() {
    const [event, setEvent] = useState(0);
    const [pid, setPid] = useState("");
    const [position, setPosition] = useState("");
    const [partData, setPartData] = useState([]);
    // 2. Add isLoading state, initialized to false as data loads on user action
    const [isLoading, setIsLoading] = useState(false);

    const [tableControls, setTableControls] = useState({
        page: 1,
        length: 100,
        sortField: "_id",
        sortDir: -1,
        search: "",
    });

    // 3. Update getPartData to manage loading state
    const getPartData = async (event) => {
        if (!localStorage.getItem("nssc-admin-token")) {
            window.location.href = "/login";
            return;
        }
        setIsLoading(true); // Show loader before API call
        callBackend({
            method: "GET",
            endpoint: "/admin/event/winner/" + event,
            onSuccess: (res) => {
                setPartData(res.data);
                setIsLoading(false);
            },
            onError: (error) => {
                console.error("Failed to fetch winners:", error);
                setPartData([]);
                setIsLoading(false);
            },
        });
    };

    const columns = {
        pid: "PID",
        name: "Name",
        college: "College/School",
        position: "Position",
        cid: "Certificate",
    };

    return (
        <Container
            fluid
            style={{
                marginTop: "20px",
                marginBottom: "20px",
            }}
        >
            <h1>Winners</h1>
            <div>
                <select
                    value={event}
                    onChange={(e) => {
                        const selectedEvent = e.target.value;
                        setEvent(selectedEvent);
                        if (selectedEvent != 0) {
                            getPartData(selectedEvent);
                        } else {
                            setPartData([]);
                        }
                    }}
                >
                    <option value={0}>Select Event</option>
                    {Object.keys(EventsData).map((val) => {
                        return (
                            <option value={val} key={val}>
                                {EventsData[val].name}
                            </option>
                        );
                    })}
                </select>
                &nbsp;&nbsp;Value:&nbsp;&nbsp;
                <input
                    type="text"
                    placeholder="PID"
                    value={pid}
                    onChange={(e) => setPid(e.target.value)}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <select
                    value={position}
                    onChange={(e) => setPosition(e.target.value)}
                >
                    <option value={""}>Select Position</option>
                    <option value={"1st"}>1st</option>
                    <option value={"2nd"}>2nd</option>
                    <option value={"3rd"}>3rd</option>
                </select>
                &nbsp;&nbsp;Value:&nbsp;&nbsp;
                <Button
                    variant="primary"
                    onClick={() => {
                        if (event === 0 || pid === "" || position === "") {
                            alert("Please fill all fields");
                            return;
                        }
                        callBackend({
                            method: "POST",
                            endpoint: "/admin/event/winner/" + event,
                            data: { pid: pid, position: position },
                            onSuccess: (res) => {
                                getPartData(event);
                                setPid("");
                                setPosition("");
                            },
                        });
                    }}
                >
                    Mark Winner
                </Button>
            </div>
            <br />

            {isLoading ? (
                <Loader />
            ) : (() => {
                const q = (tableControls.search || "").trim().toLowerCase();
                const searched = q
                    ? partData.filter((p) =>
                        Object.values(p || {}).some((v) => {
                            if (v === null || v === undefined) return false;
                            if (typeof v === "object") {
                                try {
                                    return JSON.stringify(v).toLowerCase().includes(q);
                                } catch (e) {
                                    return false;
                                }
                            }
                            return String(v).toLowerCase().includes(q);
                        })
                    )
                    : partData;
                const start = (tableControls.page - 1) * tableControls.length;
                const pageSlice = searched.slice(start, start + tableControls.length);
                return (
                    <DataTable
                        columns={columns}
                        data={pageSlice}
                        count={searched.length}
                        tableControls={tableControls}
                        setTableControls={setTableControls}
                    />
                );
            })()}
        </Container>
    );
}